import { Box } from '@mui/material';
import UpdateIcon from '@mui/icons-material/Update';
import PriorityHighOutlined from '@mui/icons-material/PriorityHighOutlined';
import { FieldProps, TextFieldWithPrefix, useFieldHelper } from 'framework/ui/field';
import { useDateService } from 'framework/utils';
import { ASSUMPTION_STATUS, AssumptionType } from '../../types';

type LastUpdateFieldProps = FieldProps & {
  createSource?: string;
};

const LastUpdateField = (props: LastUpdateFieldProps) => {
  const { createSource = 'createdAt', source } = props;
  const { getValue: getUpdatedAt, getData } = useFieldHelper<string>({ source });
  const { getValue: getCreatedAt } = useFieldHelper<string>({ source: createSource });
  const { datesDifference, getToday } = useDateService();

  const actualDate = getUpdatedAt() || getCreatedAt();

  if (!actualDate) {
    return null;
  }

  const row = getData() as AssumptionType | undefined;
  const needsAttention = !!row?.isVerificationRequired && row?.status !== ASSUMPTION_STATUS.INACTIVE;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <TextFieldWithPrefix
        {...props}
        tooltipProps={{
          title: 'Last update',
          children: (
            <div>
              <UpdateIcon sx={{ color: 'text.secondary' }} />
            </div>
          ),
        }}
        label=""
        value={
          <Box component="span" sx={{ color: needsAttention ? 'error.main' : 'inherit' }}>
            {datesDifference(getToday(), actualDate)}
          </Box>
        }
      />
      {needsAttention && <PriorityHighOutlined sx={{ color: 'error.main', fontSize: 18 }} />}
    </Box>
  );
};

export default LastUpdateField;
